
import {AbstractUI} from "./AbstractUI";
import bidello,{component} from "bidello";
import {States} from "../services/StateManager";
import {Ajax} from "../services/Ajax";

export class FilterDrawer extends component(AbstractUI){

    close (){

        this.domElement.classList.remove('open');

    }

    open (){

        this.domElement.classList.add('open');

    }

    onStateChange(state){

        if (state.state == States.filters.OPEN_STATE)this.domElement.classList.add('open');
        if (state.state == States.filters.CLOSE_STATE)this.domElement.classList.remove('open');
        if (state.state == States.filters.TOGGLE_STATE)this.domElement.classList.toggle('open');

    }



}